/** Máximo precio ARS (filtros catálogo y publicación). */
export const PRECIO_MAX_ARS = 99_000_000;
